import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ActivacionCargueI } from 'src/app/modelos/ActivacionCargue';
import { EstadoInfoChvI } from 'src/app/modelos/EstadoInformacionChv';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { VistaAdminInfoI } from 'src/app/modelos/VistaAdminInfo';
import { VistaHistoricoActivacionI } from 'src/app/modelos/VistaHistorialActivacion';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AdmininformacionService } from 'src/app/servicios/admininfo/admininformacion.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { AnalisisService } from 'src/app/servicios/analisis/analisis.service';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-activarcargue',
  templateUrl: './activarcargue.component.html',
  styleUrls: ['./activarcargue.component.css']
})
export class ActivarcargueComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  PeriodosConsultar : PeriodoReporteI[];

  aniosVigen: Number[];
  PeriodoSeleccionado : PeriodoReporteI = new PeriodoReporteI;
  anioConsulta : Number = 0;
  consucutivoConsulta : Number = 0;

  IdPeriodoConsulta : BigInteger;
  ListaEstadosFuentes : VistaAdminInfoI[];
  EstadoInformacionSelect : EstadoInfoChvI = new EstadoInfoChvI;
  PeriodoModalInactivar : String;
  Fuente : fuenteI = new fuenteI;
  PeriodoActivo : PeriodoReporteI = new PeriodoReporteI;
  ActivarCargueModalInactivar : Boolean;
  BtnInactivar : Boolean;
  BtnActivar : Boolean;
  CambioEstadoCargue : ActivacionCargueI = new ActivacionCargueI;
  ObservacionInactivar : String;
  ObservacionActivar : String;
  HistorialActivacionCargue : VistaHistoricoActivacionI[];

  page : number;

  @ViewChild('openmodalinactivarcargue') openmodalinactivarcargue: ElementRef;
  @ViewChild('closemodalinactivarcargue') closemodalinactivarcargue: ElementRef;
  @ViewChild('openmodalactivarcargue') openmodalactivarcargue: ElementRef;
  @ViewChild('closemodalactivarcargue') closemodalactivarcargue: ElementRef;
  @ViewChild('openmodalverhistorial') openmodalverhistorial: ElementRef;
  @ViewChild('closemodalverhistorial') closemodalverhistorial: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private analisisService:AnalisisService,
    private admininfo:AdmininformacionService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ estados"
        }
    };
    this.ActivarCargueModalInactivar = false;
    this.BtnInactivar = false;
    this.BtnActivar = false;
    this.analisisService.consultarPeriodoActivoCHV().subscribe(PActivo=>{
      this.anioConsulta = Number(PActivo.anio);
      this.consucutivoConsulta = Number(PActivo.consecutivoPeriodo);
      this.PeriodoActivo = PActivo;
      this.PeriodoSeleccionado = PActivo;
      this.CosultarListaEstados();
    });
    this.api.listaPeriodosCalendario().subscribe(result=>{
      this.PeriodosConsultar = result;
    });
    /*this.admininfo.TodosEstadosPeriodoActivoAdminInfoChv().subscribe(result1=>{
      this.ListaEstadosFuentes = result1;
      this.dtTrigger.next();
    });*/
    this.analisisService.getListaAniosVigenciaChv().subscribe(respuesta0=>{
      this.aniosVigen = respuesta0;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  RegresarAdminChv(){
    this.router.navigate(['admininfochv']);
  }

  CosultarListaEstados(){
    if(this.consucutivoConsulta==0 || this.anioConsulta == 0){
      console.log("Seleccione periodo completo");
    } else {
      this.api.PeriodoPorConsecutivoAnio(this.consucutivoConsulta, this.anioConsulta).subscribe(resultado1=>{
        this.PeriodoSeleccionado = resultado1;
        this.PeriodoActivo = resultado1;
        this.api.EstadosInfoParaPeriodoChv(resultado1.id).subscribe(Lista2=>{
          //this.ListaEstadosFuentes = Lista2;
          if (this.dtElement.dtInstance) {
            this.dtElement.dtInstance.then((dtInstance: any) => {
              dtInstance.destroy();
              this.ListaEstadosFuentes = Lista2;
              this.dtTrigger.next();
            });
          } else {
            this.ListaEstadosFuentes = Lista2;
            this.dtTrigger.next();
          }
        });
      });
    }
  }

  /*CosultarListaEstados(IdPeriodo){
    this.IdPeriodoConsulta = IdPeriodo;
    this.api.PeriodoPorId(IdPeriodo).subscribe(Result2_2=>{
      this.PeriodoActivo = Result2_2;
    });
    this.api.EstadosInfoParaPeriodoChv(IdPeriodo).subscribe(result2=>{
      this.ListaEstadosFuentes = result2;
    });
  }*/

  VerificarCondiciones(IdEstadoInfor){
    let FechaHoy = new Date()
    let HoyDia = FechaHoy.getDate();
    let HoyMes = FechaHoy.getMonth()+1;
    let HoyAnio = FechaHoy.getFullYear();
    let VerificarRecoleccion = this.PeriodoActivo.fechaFinProcesamiento.split("/");
    if ((HoyAnio == +VerificarRecoleccion[2]) && (HoyMes <= +VerificarRecoleccion[1]) && (HoyDia <= +VerificarRecoleccion[0])){
      this.api.ConsultarEstadoInfoPorId(IdEstadoInfor).subscribe(Result3=>{
        if ((Result3.estadocargue=="Activo") && (Result3.estado=="Aprobado") && (Result3.novedadUsu!="14. Certificado de No Movimiento")){
          this.IniciarInactivacion(Result3.id);
        }else if ((Result3.estadocargue=="Activo") && (Result3.estado=="Cargado") && (Result3.novedadUsu!="14. Certificado de No Movimiento")){
          this.IniciarInactivacion(Result3.id);
        }else if ((Result3.estadocargue=="Activo") && (Result3.estado=="Pendiente") && (Result3.novedadUsu=="0. Pendiente")){
          this.toastr.warning('Solo se Inactiva reportes que tengan Estado Fuente: Cargado o Aprobado.','Advertencia!');
        }else if ((Result3.estadocargue=="Activo") && (Result3.estado=="En Proceso") && (Result3.novedadUsu=="0. Pendiente")){
          this.toastr.warning('Solo se Inactiva reportes que tengan Estado Fuente: Cargado o Aprobado.','Advertencia!');
        }else if ((Result3.estadocargue=="Activo") && (Result3.estado=="En cargue") && (Result3.novedadUsu=="0. Pendiente")){
          this.toastr.warning('Solo se Inactiva reportes que tengan Estado Fuente: Cargado o Aprobado.','Advertencia!');
        }else if ((Result3.estadocargue=="Activo") && (Result3.estado=="Aprobado") && (Result3.novedadUsu=="14. Certificado de No Movimiento")){
          this.IniciarActivacion(Result3.id);
        }else if ((Result3.estadocargue=="Activo") && (Result3.estado=="Cargado") && (Result3.novedadUsu=="14. Certificado de No Movimiento")){
          this.IniciarActivacion(Result3.id);
        }else if ((Result3.estadocargue=="Inactivo") && (Result3.estado=="Pendiente") ){
          this.IniciarActivacion(Result3.id);
        }else{
          this.toastr.warning('La fuente no ha reportado información en el periodo.','Advertencia!');
        }
      });
    }else{
      this.toastr.warning('Cargue fuera del periodo en referencia.','Advertencia!');
    }
  }

  IniciarInactivacion(IdEstadoInfor){
    this.BtnInactivar = false;
    this.openmodalinactivarcargue.nativeElement.click();
    this.ObservacionInactivar = "";
    this.CambioEstadoCargue.errorSCT = false;
    this.CambioEstadoCargue.errorSV = false;
    this.CambioEstadoCargue.errorNC = false;
    this.api.ConsultarEstadoInfoPorId(IdEstadoInfor).subscribe(Result3=>{
      this.EstadoInformacionSelect = Result3;
      this.PeriodoModalInactivar = Result3.anio+" - "+Result3.periodo;
      this.api.getFuenteById(Result3.fuente.id).subscribe(Result4=>{
        this.Fuente = Result4;
      });
    });
  }

  InactivarCargue(){
    this.BtnInactivar = true;
    this.CambioEstadoCargue.idFte = this.EstadoInformacionSelect.fuente.id;
    this.CambioEstadoCargue.idEstinf = this.EstadoInformacionSelect.id;
    this.CambioEstadoCargue.idPeriodo = this.PeriodoSeleccionado.id;
    this.CambioEstadoCargue.usuario = localStorage.getItem('usuario');
    this.CambioEstadoCargue.observacion = this.ObservacionInactivar;
    if(this.ObservacionInactivar.length == 0 || this.ObservacionInactivar.length == null){
      this.toastr.warning('Debe ingresar observación.','Advertencia!');
      this.BtnInactivar = false;
    } else if(this.ObservacionInactivar.length < 20){
      this.toastr.warning('Observación debe tener mínimo 20 caracteres.','Advertencia!');
      this.BtnInactivar = false;
    } else if(this.ObservacionInactivar.length > 500){
      this.toastr.warning('Observación debe tener máximo 500 caracteres.','Advertencia!');
      this.BtnInactivar = false;
    } else if(!this.CambioEstadoCargue.errorSCT && !this.CambioEstadoCargue.errorSV && !this.CambioEstadoCargue.errorNC){
      this.toastr.warning('Debe seleccionar al menos una variable que presente error.','Advertencia!');
      this.BtnInactivar = false;
    } else {
      console.log(this.CambioEstadoCargue);
      this.api.InactivarCargueChv(this.CambioEstadoCargue).subscribe(Result5=>{
        if(Result5){
          this.ActivarCargueModalInactivar = true;
          this.toastr.success('Se inactivo el cargue satisfactoriamente.','OK!');
          this.CosultarListaEstados();
        }
      });
    }
  }

  ActivarCargueDesdeInactivar(){
    this.CambioEstadoCargue.idFte = this.EstadoInformacionSelect.fuente.id;
    this.CambioEstadoCargue.idEstinf = this.EstadoInformacionSelect.id;
    this.CambioEstadoCargue.idPeriodo = this.PeriodoSeleccionado.id;
    this.CambioEstadoCargue.usuario = localStorage.getItem('usuario');
    this.CambioEstadoCargue.tipo = "Activar";
    this.CambioEstadoCargue.observacion = "Se activa cargue por inactivación en el mismo periodo.";
    this.CambioEstadoCargue.errorSCT = false;
    this.CambioEstadoCargue.errorSV = false;
    this.CambioEstadoCargue.errorNC = false;
    //console.log(this.CambioEstadoCargue);
    this.api.ActivarCargueDesdeInactivarModalChv(this.CambioEstadoCargue).subscribe(Result6=>{
      if(Result6){
        this.toastr.success('Se activo el cargue a la fuente correctamente.','OK!');
        this.BtnInactivar = false;
        this.CosultarListaEstados();
        this.closemodalinactivarcargue.nativeElement.click();
      }
    });
  }

  IniciarActivacion(IdEstadoInfor){
    this.openmodalactivarcargue.nativeElement.click();
    this.ObservacionActivar = "";
    this.api.ConsultarEstadoInfoPorId(IdEstadoInfor).subscribe(Result7=>{
      this.EstadoInformacionSelect = Result7;
      this.PeriodoModalInactivar = Result7.anio+" - "+Result7.periodo;
      this.api.getFuenteById(Result7.fuente.id).subscribe(Result8=>{
        this.Fuente = Result8;
      });
    });
  }

  ActivarCargue(){
    this.BtnActivar = true;
    this.CambioEstadoCargue.idFte = this.EstadoInformacionSelect.fuente.id;
    this.CambioEstadoCargue.idEstinf = this.EstadoInformacionSelect.id;
    this.CambioEstadoCargue.idPeriodo = this.PeriodoSeleccionado.id;
    this.CambioEstadoCargue.usuario = localStorage.getItem('usuario');
    this.CambioEstadoCargue.tipo = "Activar";
    this.CambioEstadoCargue.observacion = this.ObservacionActivar;
    this.CambioEstadoCargue.errorSCT = false;
    this.CambioEstadoCargue.errorSV = false;
    this.CambioEstadoCargue.errorNC = false;

    if(this.ObservacionActivar.length == 0 || this.ObservacionActivar.length == null){
      this.toastr.warning('Debe ingresar observación.','Advertencia!');
      this.BtnActivar = false;
    }else if(this.ObservacionActivar.length < 20){
      this.toastr.warning('Observación debe tener mínimo 20 caracteres.','Advertencia!');
      this.BtnActivar = false;
    }else if(this.ObservacionActivar.length > 500){
      this.toastr.warning('Observación debe tener máximo 500 caracteres.','Advertencia!');
      this.BtnActivar = false;
    }else{
      this.api.ActivarCargueChv(this.CambioEstadoCargue).subscribe(Result9=>{
        if(Result9){
          this.toastr.success('Se activo el cargue a la fuente correctamente.','OK!');
          this.BtnActivar = false;
          this.CosultarListaEstados();
          this.closemodalactivarcargue.nativeElement.click();
        }
      });
    }
  }

  VerHistorial(IdEstadoInfor){
    this.openmodalverhistorial.nativeElement.click();
    this.api.ConsultarEstadoInfoPorId(IdEstadoInfor).subscribe(Result10=>{
      this.EstadoInformacionSelect = Result10;
      this.PeriodoModalInactivar = Result10.anio+" - "+Result10.periodo;
      this.api.getFuenteById(Result10.fuente.id).subscribe(Result11=>{
        this.Fuente = Result11;
        this.api.HistorialActivacionCargueChv(IdEstadoInfor).subscribe(Result12=>{
          this.HistorialActivacionCargue = Result12;
        });
      });
    });
  }





}
